import {Container, ContainerProps} from "@mui/material";
import React, {useLayoutEffect, useRef} from "react";
import {setScrollRestorationTarget} from "~/lib/scrollrestoration";
import useMergedRef from "@react-hook/merged-ref";


export type AbsoluteContainerProps = ContainerProps & {
    top?: number
}



export const AbsoluteContainer = React.forwardRef<HTMLDivElement, AbsoluteContainerProps>((props: AbsoluteContainerProps, ref) => {
    const innerRef = useRef<HTMLDivElement>(null);
    const mergedRef = useMergedRef<HTMLDivElement>(ref, innerRef);
    const containerProps: ContainerProps = {
        ...props,
        className: [props.className].filter(Boolean).join(" "),
        style: {
            ...props.style,
            position: "absolute",
            top: props.top || 0,
            bottom: 0,
            left: 0,
            right: 0,
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            scrollbarGutter: 'stable both-edges'
        }
    }

    useLayoutEffect(() => {
        setScrollRestorationTarget(innerRef.current);
        return () => {
            setScrollRestorationTarget(null);
        }
    }, []);

    return (
        <Container {...containerProps} ref={mergedRef}>
            {props.children}
        </Container>
    )
})
